<!-- eslint-disable max-len -->
<template>
  <div class="component-card">
    <div class="container-top-admin">
      <div class="m__b--20 m__l--20">
        <div class="top-label-admin font-gotham-bold">
          Report Buku Saku Siswa
        </div>
      </div>
      <div class="d-flex">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'prestasi'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="tabSelected = 'prestasi'">
          PRESTASI
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'pelanggaran'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="tabSelected = 'pelanggaran'">
          PELANGGARAN
        </div>
      </div>
    </div>

    <div class="m__t--45">
      <j-prestasi v-if="tabSelected === 'prestasi'" />
      <j-pelanggaran v-if="tabSelected === 'pelanggaran'" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

import jPrestasi from '@/views/kesiswaan/buku-saku/tab-component-report/jPrestasi';
import jPelanggaran from '@/views/kesiswaan/buku-saku/tab-component-report/jPelanggaran';

export default {
  components: {
    jPrestasi,
    jPelanggaran,
  },
  data() {
    return {
      tabSelected: 'prestasi',
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreKesiswaan', ['getListSiswa', 'getListKelasAll']),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/buku-saku/jBukuSakuReport.vue